'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { useNavigationHistoryStore } from '~/stores/useNavigationHistoryStore';

export const useNavigationHistory = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const push = useNavigationHistoryStore((s) => s.push);

  useEffect(() => {
    const search = searchParams.toString();
    const route = search ? `${pathname}?${search}` : pathname;

    // SearchInput debounces URL updates (300ms + flush on blur), so each
    // searchParams change is already a settled query — no extra debounce here.
    push(route);
  }, [pathname, push, searchParams]);
};
